import { l } from '../lodashImports'

export function mapToArray<T, K>(map: { [k in keyof K]: T }): T[] {
	return l.map(Object.keys(map), (cKey) => map[cKey])
}
